{
  "title": "Aganazzar's Scorcher",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level evocation",
  "level": 2,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a red dragon’s scale)",
  "duration": "Instantaneous",
  "description": [
    "A line of roaring flame 30 feet long and 5 feet wide emanates from you in a direction you choose. Each creature in the line must make a Dexterity saving throw. A creature takes 3d8 fire damage on a failed save, or half as much damage on a successful one.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d8 for each slot level above 2nd."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
